import React, { useRef, useState } from 'react'
import { SelectValue } from 'antd/lib/select'
import dp from 'dot-prop-immutable'

import { Select } from 'src/components/Formik'
import { SelectProps } from 'src/components/Formik/Select'
import CitiesService from 'src/services/api/cities'
import { AddressCity, Id } from 'src/types'

type Props = Omit<SelectProps, 'loading' | 'options'> & {
  state: Id
}

export default function SelectCity({
  defaultActiveFirstOption = true,
  formikProps,
  name,
  style,
  onChange,
  state,
  ...props
}: Props) {
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState<AddressCity[]>([])
  const [searchValue, setSearchValue] = useState<string>()

  const refTimeout = useRef<NodeJS.Timeout>(null)

  function setFieldValue(value: string) {
    formikProps.setFieldValue(name, value)

    formikProps.setFieldValue(
      name.replace('_id', ''),
      list.find(item => +item.city_id === +value)
    )
  }

  return (
    <Select
      {...props}
      dataTestId="city-list"
      defaultActiveFirstOption={defaultActiveFirstOption}
      filterOption={false}
      formikProps={formikProps}
      loading={loading}
      name={name}
      style={style}
      onChange={(
        value: SelectValue,
        option: React.ReactElement<any> | React.ReactElement<any>[]
      ) => {
        setFieldValue(`${value}`)
        onChange && onChange(value, option)
      }}
      onSearch={value => {
        setSearchValue(value)

        if (value) {
          clearTimeout(refTimeout.current)

          refTimeout.current = setTimeout(async () => {
            setLoading(true)

            const response = await CitiesService.getAll({
              state,
              queryName: value
            })

            setLoading(false)

            if (response.data) {
              setList(response.data)
            }
          }, 500)
        }
      }}
      options={
        !searchValue && dp.get(formikProps.values, name)
          ? (() => {
              const cityObj = dp.get(
                formikProps.values,
                name.replace('_id', '')
              )

              return [
                {
                  label: cityObj?.name,
                  title: cityObj?.name,
                  value: `${cityObj?.city_id}`
                }
              ]
            })()
          : list.map(city => ({
              label: city.name,
              title: city.name,
              value: `${city.city_id}`
            }))
      }
      showSearch
    />
  )
}
